import { FacetGroup } from './facet-group.class';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';

export class FilterGroup {

    facetGroups: FacetGroup[];
    layoutConfig: any;
    showMoreModal: ModalComponent;
    style: any;

    constructor(
        public label: string,
        public displayLimit: number,
        public config: any,
        public toolTipText: string,
        facetGroups: Array<any>,
        group
    ) {
        this.facetGroups = this.mapFacetGroups(facetGroups, group);
    }

    mapFacetGroups(facetGroups: Array<any>, group: string): FacetGroup[] {
        return facetGroups.map((facetGroup) => new FacetGroup(facetGroup.label, facetGroup.facets, group));
    }
}
